// SidebarBucketAddButton.jsx

import React, { useState } from 'react';

// Context
import { useTheme } from 'context/ThemeContext';
import { useUI } from 'context/UIContext';

// CSS
import './SidebarBucketAddButton.css';

// Icons
import Icon from 'svg/Icon';

/**
 * SidebarBucketAddButton
 * 
 * Description
 *  
 *
 * @returns {ReactNode} - SidebarBucketAddButton.
 */
const SidebarBucketAddButton = React.memo(({ label, onClick }) => {

    // ----- CONTEXT ----- //

    // Theme Context

    const { theme } = useTheme();
    const { isSidebarRailCompact } = useUI();
    const compact = Boolean(isSidebarRailCompact);
    const iconSize = compact ? 22 : 18;

    // ----- STATE ----- //

    // Hover state

    const [hovered, setHovered] = useState(false);

    // ----- RENDER ----- //

    return (

        <div
          className={[
            'sidebar-bucket-add-button-container',
            compact ? 'is-rail-compact' : '',
          ].filter(Boolean).join(' ')}
          style={{
                color: hovered ? theme.foreground : theme.foregroundMuted
            }}
          title={compact ? (label || '') : undefined}
          onClick={onClick}
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
        >
            <span className="sidebar-bucket-add-button-icon">
              <Icon
                iconKey="add"
                width={iconSize}
                height={iconSize}
                color={hovered ? theme.foreground : theme.foregroundMuted}
              />
            </span>
            {!compact ? label : null}
        </div>
    );

});

// Dev Tools
SidebarBucketAddButton.displayName = 'SidebarBucketAddButton';

export default SidebarBucketAddButton;
